import React from 'react';
import { Dialog as MuiDialog } from '@material-ui/core';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';

const sizeMap = {
  'extra-small': '15.25rem',
  small: '26.25rem',
  440: '27.5rem',
  medium: '34.875rem',
  large: '46.25rem',
  'extra-large': '72rem',
};
const useStyles = makeStyles(theme => ({
  paperScrollPaper: {
    borderRadius: '0.375rem',
    height: 'auto',
    minHeight: '12.5rem',
    padding: '1.5rem',
    width: props => sizeMap[props.size],
    maxWidth: '100% !important',
    overflow: 'visible',
  },
  paperScrollBody: {
    width: props => (props.fullScreen ? '100%' : sizeMap[props.size]),
    maxWidth: '100% !important',
    overflow: 'visible',
    padding: props => (props.withPadding ? '1.5rem' : '0'),
  },
  scrollBody: {
    position: 'fixed',
    width: '100%',
  },
  paper: {
    color: theme.palette.secondary.text,
    margin: 0,
  },
}));

const Dialog = (props) => {
  const classes = useStyles(props);
  return (
    <MuiDialog
      disableEnforceFocus
      classes={{
        paperScrollPaper: classes.paperScrollPaper,
        paperScrollBody: classes.paperScrollBody,
        scrollBody: classes.scrollBody,
        paper: classes.paper,
      }}
      className={props.className}
      scroll="body"
      {...props}
    >
      {props.children}
    </MuiDialog>
  );
};

Dialog.propTypes = {
  size: PropTypes.string,
  classes: PropTypes.element.isRequired,
  withPadding: PropTypes.bool,
};

Dialog.defaultProps = {
  size: 'medium',
  withPadding: true,
};

export default Dialog;
